<template>
    <div>
      <Head title="Credit Notes" />
      <h1 class="mb-8 text-3xl font-bold">Credit Notes</h1>
      <div class="flex items-center justify-between mb-6">
        <search-with-date-range v-model="search.search" class="mr-4 w-full max-w-md"/>
        <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
      </div>
      <div
          class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
        <a
          v-if="creditNotes.data.length > 0 && url()"
          class="btn-orange px-3 py-2 text-xs cursor-pointer mr-2"
          :href="`/back-log-credit-notes/downloads${url()}`" 
          download
          target="__blank"
          title="Download"
        >
          <span>Download</span>
        </a>
          <Link
            href="/upload-credit-notes"
            class="btn-orange px-3 py-2 text-xs"
          >
            Add Upload 
          </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-3 border border-dark">Date</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Credit Note Number</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Middleware Number</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Invoice Ref No</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Control Unit</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Amount</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Status</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Message</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Qr Code</th>
                    <th class="pb-3 pt-3 px-3 border border-dark">Action</th>
                </tr>
                <tr v-for="credit_note in creditNotes.data" :key="credit_note.id" class="text-left">
                    <td class="pb-3 pt-3 px-3 border border-dark">{{ credit_note.date }}</td>
                    <td class="pb-3 pt-3 px-3 border border-dark">{{ credit_note.traderSystemInvoiceNumber }}</td>
                    <td class="pb-3 pt-3 px-3 border border-dark">{{ credit_note.middlewareInvoiceNumber }}</td>
                    <td class="pb-3 pt-3 px-3 border border-dark">{{ credit_note.invoiceNo }}</td>
                    <td class="pb-3 pt-3 px-3 border border-dark">{{ credit_note.controlCode }}</td>
                    <td class="pb-3 pt-3 px-3 border border-dark">{{ credit_note.amount }}</td>
                    <td class="pb-3 pt-3 px-3 border border-dark">{{ credit_note.status }}</td>
                    <td class="pb-3 pt-3 px-3 border border-dark">{{ credit_note.message }}</td>
                    <td class="pb-3 pt-3 px-3 border border-dark"><a :href="`${credit_note.qrCode}`" target="_blank">View</a></td>
                    <td class="pb-3 pt-3 px-3 border border-dark"><a class="bg-orange-500 text-white text-sm py-1 px-2 rounded hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-300" :href="`back-log-credit-notes/${credit_note.id}/download`" target="_blank">Download</a></td>
                </tr>
                <tr v-if="!creditNotes.data.length">
                    <td class="px-3 py-3 border-t border border-dark" colspan="7">No data found</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="creditNotes.links" />
    </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'
import throttle from 'lodash/throttle'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchWithDateRange,
    DateRange
  },
  layout: Layout,
  props: {
    filters: Object,
    creditNotes: Object,
  },
  data() {
    return {
        form: this.$inertia.form({}),
        isUploading: false,
        search: {
          dateValue: this.filters.dateValue,
          search: this.filters.search,
        },
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/back-log-credit-notes/', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    url() {
      let query = '';
      if (this.search.search) {
        query += `search=${this.search.search}`;
      }
      if (this.search.dateValue) {
        if (query) {
          query += '&';
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>